import { formatDate } from 'kickstart-ui/src/helpers/dates.js';
import Timesheets from '@Vault/Timesheets/repositories/TimesheetRepository.js';

/**
 * @param {string} from
 * @param {string} to
 */
export function fetchHolidays({commit, state}, {from, to}) {
    const today = new Date();
    from = from ?? formatDate(new Date(today.getFullYear() - 1, today.getMonth(), today.getDate()));
    to = to ?? formatDate(new Date(today.getFullYear() + 1, today.getMonth(), today.getDate()));

    // if already within the loaded timeframe, return
    if ( state.holidays_from <= from && to <= state.holidays_to ) {
        return Promise.resolve();
    }

    // ensure contiguous loaded holiday range
    if ( to < state.holidays_from ) {
        to = state.holidays_from;
    } else if ( from > state.holidays_to ) {
        from = state.holidays_to;
    }

    return Timesheets.get('holidays', { from, to })
        .then(({data}) => {
            commit('SET_HOLIDAYS', {from, to, holidays: data});
        });
}

/**
 * @param {function} commit
 * @param {array} country_holidays
 */
export function setCountryHolidays({commit}, country_holidays) {
    commit('SET_COUNTRY_HOLIDAYS', country_holidays);
}
